import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { ResponseDto as CityInfoResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';
import { IPromoline } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info/dto/IPromoline';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { COOKIE_DOMAIN } from '~/src/constants';

dayjs.extend(utc);
class CurrentCity {
    constructor(
        private readonly cityInfo: CityInfoResponseDto,
    ) {}

    public prepare() {
        return this.prepareCity();
    }

    private prepareCity(): ICurrentCity | Omit<ICurrentCity, 'abnTests'> {
        return {
            domain: this.cityInfo.domain,
            hostname: `${this.cityInfo.domain}${COOKIE_DOMAIN}`,
            name: this.cityInfo.name,
            cityId: this.cityInfo.city_id,
            phone: this.cityInfo.phone_code === '0'
                ? this.cityInfo.sale_phone
                : `+7 (${this.cityInfo.phone_code}) ${this.cityInfo.sale_phone}`,
            callCenter: this.cityInfo.call_center_phone?.length > 10
                ? this.cityInfo.call_center_phone
                : `+7 (${this.cityInfo.phone_code}) ${this.cityInfo.call_center_phone}`,
            callcenterWorkTimeStart: this.formatUtcTime(this.cityInfo.callcenter_work_time_start, this.cityInfo.time_zone),
            callcenterWorkTimeEnd: this.formatUtcTime(this.cityInfo.callcenter_work_time_end, this.cityInfo.time_zone),
            billingHost: this.cityInfo.billing_host,
            cityIn: this.cityInfo.pred_name,
            cityTo: this.cityInfo.dat_name,
            internet: !!+this.cityInfo.has_internet,
            ctv: !!+this.cityInfo.has_ctv,
            ktv: !!+this.cityInfo.has_ktv,
            telephony: !!+this.cityInfo.has_telephony,
            videocontrol: !!+this.cityInfo.has_videocontrol,
            phoneCode: this.cityInfo.phone_code === '0'
                ? 0
                : this.cityInfo.phone_code,
            supportPhone: this.cityInfo.phone_code === '0'
                ? this.cityInfo.support_phone
                : `+7 (${this.cityInfo.phone_code}) ${this.cityInfo.support_phone}`,
            companyName: this.cityInfo.company_name,
            legalEntity: this.cityInfo.legal_entity,
            logo: this.cityInfo.logo,
            logoFull: this.cityInfo.logoFull,
            logo_narrow: this.cityInfo.logo_narrow,
            image_map: this.cityInfo.image_map,
            image_map_webp: this.cityInfo.image_map_webp,
            region: this.cityInfo.region_id || null,
            hasFreeDeliveryAndInstallation: !!+this.cityInfo.has_free_delivery_and_installation,
            has_QPS: this.cityInfo.has_QPS,
            plAvailable: this.cityInfo.pl_available,
            loyaltyProgramCashback: this.cityInfo.loyalty_program_cashback,
            timeZone: this.cityInfo.time_zone,
            withPromoLines: this.filterPromoLines(this.cityInfo.promolines),
            sso: this.cityInfo.sso,
        };
    }

    private formatUtcTime(utcTime: string, timeZone: number) {
        if (!utcTime || !timeZone) {
            return;
        }

        return dayjs.utc(utcTime, 'HH:mm:ss[Z]').utcOffset(timeZone / 60).format('HH:mm');
    }

    private filterPromoLines(promoLines: IPromoline[]) {
        let hasActiveAuth = false;
        let hasActiveUnauth = false;

        if (Array.isArray(promoLines) && promoLines.length > 0) {
            promoLines
                .filter(line => line['is_active'])
                .forEach(line => {
                    hasActiveAuth = hasActiveAuth || Boolean(line['is_view_auth']);
                    hasActiveUnauth = hasActiveUnauth || Boolean(line['is_view_guest']);
                });
        }

        return {
            auth: hasActiveAuth,
            unauth: hasActiveUnauth,
        };
    }
}

export default CurrentCity;
